var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"w-nowrap mr-2",attrs:{"variant":"success"},on:{"click":function($event){return _vm.$emit('onExport')}}},[_c('span',[_vm._v("Export .CSV")])])}
var staticRenderFns = []

export { render, staticRenderFns }